module.exports = ".tmpltFormDialog {\n  margin-left: 266px; }\n\n.mat-form-field {\n  width: 200px; }\n"